<template>
  <v-card class="mb-4" elevation="2">
    <v-card-title>Team Information</v-card-title>
    <v-card-text>
      <v-text-field
          :value="team"
          @input="$emit('update:team', $event)"
          :rules="[v => !!v || 'Teamname ist erforderlich']"
          label="Teamname (erscheint auf allen Startnummern)"
          required
      ></v-text-field>
      <v-text-field
          :value="contactEmail"
          @input="$emit('update:contactEmail', $event)"
          :rules="emailRules"
          label="Kontakt E-Mail (optional, für Bestätigung)"
      ></v-text-field>
      <v-select
          :value="amount"
          @input="$emit('update:amount', $event)"
          :items="amountItems"
          item-text="label"
          item-value="name"
          label="Spende pro Person"
          required
          return-object
      ></v-select>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: 'TeamInfoCard',
  props: {
    team: {
      type: String,
      required: true
    },
    contactEmail: {
      type: String,
      default: ''
    },
    amount: {
      type: Object,
      required: true
    },
    amountItems: {
      type: Array,
      required: true
    }
  },
  computed: {
    emailRules() {
      return [
        v => !v || /.+@.+\..+/.test(v) || 'Ungültige E-Mail Adresse'
      ];
    }
  }
}
</script>
